import { gql } from '@apollo/client';

const GET_ARTICLE_NO_LOOKUP = gql`query getArticleNoLookup($companyId: Int!){
  companyAdminContext {
		salesDocuments {
			getArticleNoLookup(companyId: $companyId)
		}
	}
}`;

export default GET_ARTICLE_NO_LOOKUP;
